import React, {useEffect} from 'react';

const toggleShowPassword = (e) => {
    if(e.target.parentElement.querySelector('input')) {
        e.target.parentElement.querySelector('input').type = e.target.parentElement.querySelector('input').type === "password"?"text":"password";
    }
};

const Input = ({id, value, onChange, placeholder, className, icon=null, readOnly=false, type='text', autoComplete=null}) => {
    return <div className='input'>
        {icon?<img src={icon} className='input-icon ml5' alt=''/>:<div className='ml30'/>}
        <img src='/images/input_spacer.png' className='input-spacer' alt=''/>
        <input className={className} type={type} id={id} placeholder={placeholder} value={value} readOnly={readOnly} autoComplete={autoComplete} onChange={(e) => onChange(e)}/>
        {type==='password' && <img src='/images/show-password-icon.png' className='input-icon ml10' onClick={(e) => toggleShowPassword(e)} alt=''/> }
        {(placeholder && value.trim()!=='') && <div className='input-placeholder'>{placeholder}</div>}
    </div>;
};

export default Input;